import { Injectable } from '@angular/core';

import { RepositoryService } from '@get/services/repository';
import { GeneratedSocieteTerritoireUserApiService } from './societe-territoire-user-api-generated.service';

@Injectable({
  providedIn: 'root'
})
export class SocieteTerritoireUserApiService extends GeneratedSocieteTerritoireUserApiService {
  constructor(repo: RepositoryService) {
    super(repo);
  }
}
